export function hasNestedVerticalScrollbar(element) {
    let currentElement = element;
    while (currentElement !== document.documentElement &&
        currentElement !== null) {
        const hasVerticalScrollbar = currentElement.scrollHeight > currentElement.clientHeight;
        if (hasVerticalScrollbar) {
            return true; // Found a vertical scrollbar in one of the ancestor elements
        }
        // Move up to the next ancestor
        currentElement = currentElement.parentElement;
    }
    return false;
}
//# sourceMappingURL=hasNestedVerticalScrollbar.js.map